<div class="skeleton-shops-wrapper">
  <h3 *ngIf="showTitle" class="h3--skeleton"></h3>
  <div class="skeleton-shops-container">
    <div class="skeleton-shop-card-container" *ngFor="let shop of [1, 2, 3, 4, 5, 6, 7]">
      <skeleton-shop-tile-compact></skeleton-shop-tile-compact>
    </div>
  </div>
</div>
